<template>
  <div>
    <div class="fix-wrapper">
      <breadcrumb
        :crumbs="[$t('menu.procures'), $t('text.create')]"
      ></breadcrumb>
      <div class="container">
        <el-form ref="formObjForm" :model="formObj" size="small">
          <div class="pd20">
            <fieldset class="mgb15">
              <legend>{{ $t("text.baseInfo") }}</legend>
              <el-col :span="8">
                <el-form-item
                  :label="$t('text.handOverAt')"
                  :prop="'handOverAt'"
                  :rules="[
                    {
                      required: true,
                      message: $t('rules.required', [$t('text.handOverAt')]),
                      trigger: 'blur',
                    },
                  ]"
                  label-width="80px"
                >
                  <el-date-picker
                    size="small"
                    v-model="formObj.handOverAt"
                    type="date"
                    style="width: 100%"
                    :picker-options="pickerTodayAfterTime"
                  />
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item
                  :label="$t('text.remark')"
                  :prop="'remark'"
                  label-width="60px"
                >
                  <el-input size="small" v-model.trim="formObj.remark" />
                </el-form-item>
              </el-col>
            </fieldset>
            <fieldset class="mgb15">
              <legend>{{ $t("menu.materials") }}</legend>
              <div
                class="flex flex-between mgb10"
                v-for="(item, index) in formObj.items"
                :key="index"
              >
                <div class="mgr10">
                  <upload-single-picture v-model="item.image" />
                </div>
                <div class="flex-grow">
                  <el-row :gutter="10">
                    <el-col :span="19">
                      <el-row :gutter="10">
                        <el-col :span="8">
                          <el-form-item>
                            <el-autocomplete
                              size="small"
                              v-model="item.materialSerialNo"
                              style="width: 100%"
                              :placeholder="
                                $t('rules.mustFill', [
                                  $t('material.serialNoName'),
                                ])
                              "
                              :fetch-suggestions="querySearchSerialNo"
                              @select="handleSelectSerialNo(index)"
                            >
                              <template slot-scope="{ item }">
                                <div class="name">{{ item.serialNo }}</div>
                                <span class="addr">
                                  {{ item.name }}-{{ item.color }}
                                  <div class="addr">
                                    {{ item.suppliersNoStr }}
                                  </div>
                                </span>
                              </template>
                            </el-autocomplete>
                            <small v-if="item._localRepeatFg" class="red">{{
                              $t("rules.filledIn", [$t("material.serialNo")])
                            }}</small>
                          </el-form-item>
                        </el-col>
                        <el-col :span="8">
                          <el-form-item>
                            <el-input
                              size="small"
                              v-model.trim="item.quantity"
                              :placeholder="
                                $t('rules.mustFill', [$t('text.quantity')])
                              "
                            />
                          </el-form-item>
                        </el-col>
                        <el-col :span="8">
                          <el-form-item>
                            <el-input
                              size="small"
                              v-if="item.materialId != null"
                              v-model.trim="item.unit"
                              :placeholder="
                                $t('rules.mustFill', [$t('material.inUnit')])
                              "
                              disabled
                            />
                            <el-autocomplete
                              size="small"
                              v-if="item.materialId == null"
                              v-model.trim="item.unit"
                              style="width: 100%"
                              :placeholder="
                                $t('rules.mustFill', [$t('material.inUnit')])
                              "
                              :fetch-suggestions="querySearchUnits"
                              @select="handleSelectUnits(index)"
                            />
                          </el-form-item>
                        </el-col>
                      </el-row>
                      <el-row :gutter="10">
                        <el-col :span="8">
                          <el-form-item>
                            <el-input
                              size="small"
                              v-model.trim="item.price"
                              :placeholder="
                                $t('rules.mustFill', [$t('material.inPrice')])
                              "
                            />
                          </el-form-item>
                        </el-col>
                        <el-col :span="8">
                          <el-form-item>
                            <!-- <el-select
                              size="small"
                              v-model.trim="item.supplierId"
                              :placeholder="$t('menu.suppliers')"
                              clearable
                              filterable
                            >
                              <el-option
                                v-for="supplier in suppliers"
                                :key="supplier.id"
                                :label="supplier.name"
                                :value="supplier.id"
                              />
                            </el-select> -->

                            <el-select
                              size="small"
                              v-model="item.supplierId"
                              :placeholder="$t('menu.suppliers')"
                              filterable
                              clearable
                            >
                              <el-option-group
                                v-for="group in groupProductSuppliers(index)"
                                :key="group.label"
                                :label="group.label"
                              >
                                <el-option
                                  v-for="supplier in group.suppliers"
                                  :key="supplier.supplierId"
                                  :label="
                                    supplier.price
                                      ? supplier.supplierName +
                                        '(¥' +
                                        supplier.price +
                                        ')'
                                      : supplier.supplierName
                                  "
                                  :value="supplier.supplierId"
                                ></el-option>
                              </el-option-group>
                            </el-select>
                          </el-form-item>
                        </el-col>
                      </el-row>
                    </el-col>
                    <el-col :span="5">
                      <el-input
                        type="textarea"
                        :rows="3"
                        :placeholder="$t('text.remark')"
                        v-model="item.remark"
                      ></el-input>
                    </el-col>
                  </el-row>
                </div>
                <div class="remove-order">
                  <el-button
                    type="text"
                    size="small"
                    @click="remove(index)"
                    v-if="index != 0"
                    >{{ $t("text.remove") }}</el-button
                  >
                </div>
              </div>
              <div class="center">
                <el-button
                  v-if="formObj.items.length < 50"
                  type="info"
                  @click="addMore"
                  plain
                  round
                  >{{ $t("action.addMore") }}</el-button
                >
                <span v-else class="orange">
                  {{ $t("prompt.addMorePrompt50") }}
                </span>
              </div>
            </fieldset>
          </div>
          <div class="form-footer">
            <el-button
              type="primary"
              size="medium"
              plain
              :loading="saveDoing"
              @click="saveSubmit"
              >{{ $t("text.submit") }}</el-button
            >
            <back-button />
          </div>
        </el-form>
      </div>
    </div>
  </div>
</template>
<script>
import axios from "axios";
import Vue from "vue";
import { page } from "@/utils/mixins.js";
import Util from "@/utils/index.js";
import BackButton from "@/components/BackButton";
import UploadSinglePicture from "@/components/UploadSinglePicture";
import SupplierMms from "@/api/supplierMms.js";
import Material from "@/api/material.js";
import Procure from "@/api/procure.js";

function bulid() {
  return {
    image: null,
    materialId: null,
    materialSerialNo: null,
    materialName: null,
    subjectId: null,
    subjectName: null,
    color: null,
    colorNo: null,
    unit: null,
    quantity: null,
    price: null,
    remark: null,
    supplierId: null,
    supplierName: null,
    _localRepeatFg: false,
    materialSuppliers: [],
  };
}

export default {
  mixins: [page],
  components: { UploadSinglePicture, BackButton },
  data() {
    return {
      pickerTodayAfterTime: {
        disabledDate(time) {
          return time.getTime() < Date.now() - 8.64e7;
        },
      },
      Util: Util,
      suppliers: [],
      formObj: {
        handOverAt: null,
        remark: null,
        items: [bulid(), bulid(), bulid()],
        procureItems: [],
      },
      saveDoing: false,
    };
  },

  computed: {},
  created() {
    const self = this;
    SupplierMms.findByTenantId().then(function (res) {
      if (res.status === 200) {
        self.suppliers = res.data;
      } else {
        self.sysError();
      }
    });
  },
  methods: {
    groupProductSuppliers(idx) {
      const self = this;
      const materialSuppliers = self.formObj.items[idx].materialSuppliers;
      const materialSupplierIds = self.formObj.items[idx].materialSuppliers.map(
        (ms) => ms.supplierId
      );
      const otherSuppliers = self.suppliers.filter(
        (p) => !materialSupplierIds.includes(p.id)
      );
      let data = [];
      if (materialSuppliers.length != 0) {
        data.push({
          label: "物料供应商",
          suppliers: materialSuppliers,
        });
      }
      if (otherSuppliers.length != 0) {
        data.push({
          label: "其他供应商",
          suppliers: otherSuppliers.map((m) => {
            return {
              supplierId: m.id,
              supplierName: m.name,
            };
          }),
        });
      }
      if (data.length !== 0 && data.length == 1) {
        data[0].label = "";
      }
      return data;
    },
    querySearchSerialNo(queryString, cb) {
      const self = this;
      if (queryString == null || queryString.length < 1) {
        return;
      }
      Material.vagueFindBySerialNoOrName({ serialNo: queryString }).then(
        function (res) {
          self.materials = res.data;
          if (self.materials.length !== 0) {
            for (const material of self.materials) {
              Vue.set(material, "value", material.serialNo);
            }
          }
          cb(self.materials);
        }
      );
    },
    handleSelectSerialNo(idx) {
      const self = this;
      self.formObj.items[idx]._localRepeatFg = false;
      const item = self.materials.find(
        (p) => p.serialNo === self.formObj.items[idx].materialSerialNo
      );
      self.formObj.items[idx].materialId = item.id;
      self.formObj.items[idx].image = item.image;
      self.formObj.items[idx].materialSerialNo = item.serialNo;
      self.formObj.items[idx].materialName = item.name;
      self.formObj.items[idx].subjectId = item.subjectId;
      self.formObj.items[idx].subjectName = item.subjectName;
      self.formObj.items[idx].color = item.color;
      self.formObj.items[idx].colorNo = item.colorNo;
      self.formObj.items[idx].unit = item.inUnit;
      self.formObj.items[idx].quantity = null;
      self.formObj.items[idx].price = item.inPrice;
      self.formObj.items[idx].remark = null;
      self.formObj.items[idx].materialSuppliers = item.materialSuppliers;
      if (item.defaultSupplier != null) {
        self.formObj.items[idx].supplierId = item.defaultSupplier.supplierId;
        self.formObj.items[idx].supplierName =
          item.defaultSupplier.supplierName;
      }

      // 前台本地过滤
      const iis = self.formObj.items.filter(function (ii) {
        return ii.materialSerialNo === self.formObj.items[idx].materialSerialNo;
      });
      if (iis.length > 1) {
        self.formObj.items[idx]._localRepeatFg = true;
        return;
      }
    },

    // 单位
    querySearchUnits(queryString, cb) {
      Material.getInUnits().then(function (res) {
        const units = res.data.map((item) => {
          return { value: item };
        });
        cb(units);
      });
    },
    handleSelectUnits(index) {
      this.formObj.items[index].unit = this.formObj.items[index].unit;
    },
    //===
    addMore() {
      this.formObj.items.push(bulid());
    },
    remove(index) {
      this.formObj.items.splice(index, 1);
    },
    //===
    saveSubmit() {
      const self = this;
      self.$refs.formObjForm.validate((valid) => {
        if (valid) {
          const items = JSON.parse(JSON.stringify(this.formObj.items)).filter(
            function (item) {
              return (
                item.materialSerialNo != null &&
                item.materialSerialNo != "" &&
                item.quantity != null &&
                item.quantity != "" &&
                item.price != null &&
                item.price != ""
              );
            }
          );
          if (items.length === 0) {
            self.$message({
              message: self.$t("prompt.atLeastOneDataFill"),
              type: "warning",
            });
            return;
          }
          const data = [];
          for (const item of items) {
            if (item._localRepeatFg === true) {
              self.$message({
                message: self.$t("prompt.errorMessage"),
                type: "warning",
              });
              return;
            }
            if (!Util.regexQuantity(item.price)) {
              self.$message({
                message: self.$t("rules.regex", [self.$t("material.price")]),
                type: "warning",
              });
              return;
            }
            if (!Util.regexQuantity(item.quantity)) {
              self.$message({
                message: self.$t("rules.regex", [self.$t("text.quantity")]),
                type: "warning",
              });
              return;
            }
            if (item.supplierId == "") {
              item.supplierId = null;
            }
            if (item.supplierId != null && item.supplierId != "") {
              item.supplierName = self.suppliers.find(
                (s) => s.id === item.supplierId
              ).name;
            }
          }
          self.formObj.procureItems = items;
          self.formObj.handOverAt =
            Util.formatDateTime(self.formObj.handOverAt) + ":00";
          self.saveDoing = true;
          Procure.create(self.formObj).then(function (res) {
            if (res.status === 200) {
              self.saveDoing = false;
              self.$message({
                message: self.$t("prompt.addSuccess"),
                type: "success",
              });
              self.$router.push({ name: "mmsProcures" });
            } else {
              self.sysError();
            }
          });
        } else {
          return false;
        }
      });
    },
  },
};
</script>

<style lang="scss" scoped>
</style>